import {
  ORDER_TYPE,
  ORDER_STATUS,
  ORDER_STATUS_TYPE_MAP,
  ORDER_CARD_TYPE_TEXT_MAP,
  ORDER_TYPE_MAP,
} from '@/utils/constants';

class Order {
  constructor(order) {
    this.order = order;
    this.orderStatus = order.status;
    this.orderType = order.type;
  }

  get type() {
    return this.orderType;
  }

  get status() {
    return this.orderStatus;
  }

  get cardType() {
    if (this.type === ORDER_TYPE.NORMAL) {
      return ORDER_STATUS_TYPE_MAP[this.status];
    }
    return ORDER_TYPE_MAP[this.type];
  }

  get cardTypeDescription() {
    return ORDER_CARD_TYPE_TEXT_MAP[this.cardType];
  }

  get isDraft() {
    return this.orderType === ORDER_TYPE.DRAFT;
  }

  get isCancelled() {
    return this.orderType === ORDER_TYPE.CANCELLED;
  }

  get isCompleted() {
    return this.orderType === ORDER_TYPE.COMPLETED;
  }

  get isScheduled() {
    return this.orderStatus === ORDER_STATUS.SCHEDULED;
  }

  get isOngoing() {
    return this.orderStatus === ORDER_STATUS.ONGOING;
  }

  get isEnded() {
    return this.orderStatus === ORDER_STATUS.ENDED;
  }

  get isSharing() {
    return !!this.order?.share_link;
  }
}

export default Order;
